import { h, type VNode } from 'vue'
import type { HtmlFragmentDefinition, HtmlTagDefinition } from '#shared/model/html'

interface TagRendererMap {
  [key: string]: any
}

function renderNode(node: HtmlTagDefinition, tagRenererMap?: TagRendererMap): VNode {
  const renderedContent = renderHtmlFragment(node.content, tagRenererMap)

  const mappedTag = tagRenererMap?.[node.tag]

  if (mappedTag) {
    return h(mappedTag, node.attrs, renderedContent)
  }

  return h(node.tag, node.attrs, renderedContent)
}

export function renderHtmlFragment(
  content: HtmlFragmentDefinition | undefined,
  tagRenererMap?: TagRendererMap
): VNode | string | undefined | (VNode | string | undefined)[] {
  if (Array.isArray(content)) return content.flatMap(node => renderHtmlFragment(node, tagRenererMap))

  if (content === undefined) return
  if (content === null) return
  if (typeof content === 'string') return content
  if (typeof content === 'number') return content.toString()

  return renderNode(content, tagRenererMap)
}
